/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AutocompleteSelect from "../../../../Basis/Components/Autocomplete/AutocompleteSelect";
import i18n from "../../../../Basis/Internationalisierung/i18n";
import { languages } from "../../../../Basis/Internationalisierung/languages";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nCountries";
import Land from "../../Land";
import { useLaenderContext } from "../LaenderContext";
import LandInputProps from "./LandInputProps";

function ermittleBezeichnung(option: Land | null, istDeutsch: boolean) {
    return istDeutsch
        ? option?.bezeichnung ?? option?.bezeichnungEN ?? ""
        : option?.bezeichnungEN ?? option?.bezeichnung ?? "";
}

export default function LandInput(props: LandInputProps) {
    const { t } = useTranslation();
    const { laender } = useLaenderContext();
    const istDeutsch = props.isGermanTranslation || i18n.resolvedLanguage.startsWith(languages.de);

    const value = laender.filter(land => {
        return land.iso.toLowerCase() === props.value?.toLowerCase();
    })[0] ?? null;

    return (
        <AutocompleteSelect<Land>
            {...props}
            caption={props.caption}
            value={value}
            onChange={(land) => {
                props.onChange(land?.iso ?? "");
            }}
            getOptionSelected={(option: Land | null, value: Land | null): boolean => option?.iso === value?.iso}
            getOptionLabel={(option: Land | null): string => ermittleBezeichnung(option, istDeutsch)}
            executeQuery={() => Promise.resolve(laender)}
            filterOptions={(options, state) => {
                return options
                    .map(o => ({ ...o, value: ermittleBezeichnung(o, istDeutsch) }))
                    .filter(land => land.value.toLowerCase().includes(state.inputValue.toLowerCase()))
                    .sort((l1, l2) => l1.value.localeCompare(l2.value)) ;
            }}
            typBezeichnung={props.typBezeichnung}
            feldBezeichnung={props.feldBezeichnung}
            readonly={props.readonly}
            placeholder={t(translationKeys.landInput.placeholder)}
            tooltip={props.tooltip}
            ignoreTooltip={props.ignoreTooltip}
            required={props.required}
            disableClearable={false}
            onBlur={props.onBlur}
        />
    );
}
